import request from '@/utils/request'
import { API } from '@/config'
import { IJwt, IToken } from '@/store/models/auth.model'

export let controller: AbortController

// 创建一个新的聊天会话
export const createSession = (): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/rag/chats/new',
})

// 获取指定聊天会话下历史聊天记录
export const getSessionRecord = (chatId: number): Promise<any> => request({
    method: 'GET',
    url: `/api/pangooITMT/rag/chat/${chatId}`,
})

// 获取全部历史聊天会话
export const getSessionAll = (): Promise<{
    chatId: number
    chatTitle: string
}[]> => request({
    method: 'GET',
    url: '/api/pangooITMT/rag/chats'
})
// 编辑聊天会话标题
export const editSessionName = (data: {
    chatId: number
    title: string
}): Promise<any> => request({
    method: 'PUT',
    url: '/api/pangooITMT/rag/chats',
    data
})
// 删除会话
export const delSession = (chatId: number): Promise<any> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/rag/chats/${chatId}`,
})

// 发送消息，回答由AI生成
export const postPrompt = (data: {
    chatId: number
    messages: {
        chatId: number
        content: string
        parentId: number
        role: string
        vote: number
    }[]
}): Promise<any> => {
    const headers: any = {}
    const lang = localStorage.getItem('lang')
    if (lang) {
        if (lang === 'en') {
            headers['Accept-Language'] = 'en-US'
        } else {
            headers['Accept-Language'] = 'zh-CN'
        }
    } else {
        headers['Accept-Language'] = navigator.language || 'zh-CN'
    }
    const userInfoStr: string | null = localStorage.getItem('userInfo')
    const userInfoLocal: IJwt | IToken | null = userInfoStr && JSON.parse(userInfoStr)
    if (userInfoLocal) {
        headers.accept_token = userInfoLocal.token
        if ('nickName' in userInfoLocal) {
            headers.fullName = encodeURIComponent(userInfoLocal.nickName)
            headers.userId = userInfoLocal.login
        }
    }
    controller = new AbortController()
    return fetch(`${API}/api_backend/rag/chat/completion`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...headers
        },
        signal: controller.signal,
        body: JSON.stringify({
            ...data,
            lang: lang ?? 'zh'
        })
    })
}

// 由 AI 总结生成
export const summary = (data: {
    chatId: number
    messages: {
        chatId: number
        content: string
        parentId: number
        role: string
        vote: number
    }[]
}): Promise<any> => {
    const headers: any = {}
    const lang = localStorage.getItem('lang')
    if (lang) {
        if (lang === 'en') {
            headers['Accept-Language'] = 'en-US'
        } else {
            headers['Accept-Language'] = 'zh-CN'
        }
    } else {
        headers['Accept-Language'] = navigator.language || 'zh-CN'
    }
    const userInfoStr: string | null = localStorage.getItem('userInfo')
    const userInfoLocal: IJwt | IToken | null = userInfoStr && JSON.parse(userInfoStr)
    if (userInfoLocal) {
        headers.accept_token = userInfoLocal.token
        if ('nickName' in userInfoLocal) {
            headers.fullName = encodeURIComponent(userInfoLocal.nickName)
            headers.userId = userInfoLocal.login
        }
    }
    controller = new AbortController()
    return fetch(`${API}/api_backend/rag/chat/summary`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            ...headers
        },
        signal: controller.signal,
        body: JSON.stringify({
            ...data,
            lang: lang ?? 'zh'
        })
    })
}

// 获取最热问题
export const getHotQuestion = (): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/rag/top/problem'
})

// 清除会话聊天记录
export const delSessionMessage = (chatId: number): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/rag/message/clear',
    params: {
        chatId
    }
})
// 修改 生成内容 编辑保存
export const saveAnswer = (data: {
    messageId: number
    content: string
}): Promise<any> => request({
    method: 'PUT',
    url: '/api/pangooITMT/rag/messages',
    data
})

// 赞
export const zanMessage = (messageId: number, comment: string): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/rag/vote/like',
    data: {
        comment,
        messageId
    }
})
// 踩
export const caiMessage = (messageId: number, comment: string): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/rag/vote/dislike',
    data: {
        comment,
        messageId
    }
})
// 删除提问
export const delMessage = (messageId: number): Promise<any> => request({
    method: 'DELETE',
    url: `/api/pangooITMT/rag/messages/${messageId}`,
})

// 贡献度可检索日期范围
export const getContributeDateRange = (): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/contribution/date/range',
})
// 获取指定范围内的贡献度
export const getContribute = (params: {
    beginDate: string
    endDate: string
}): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/contribution',
    params
})

// 获取技术树
export const getTechTree = (params?: {
    id: string | number
}): Promise<any> => request({
    method: 'GET',
    url: '/api/pangooITMT/rag/tree',
    params,
})
// 获取技术树叶子节点，
export const getTechTreeLeaf = (id: string | number): Promise<any> => request({
    method: 'GET',
    url: `/api/pangooITMT/rag/tree/${id}`,
})
// 通过 ptn 获取 技术提案 id
export const getTechlId = (data: { ptns: string[] }): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/techProjectInfo/convertPtnToIds',
    data: data.ptns
})
// 生成字段标准名
export const getStandardName = (data: {
    query_key: string
    json_data: any
    lang: string
}): Promise<any> => request({
    method: 'POST',
    url: '/api/pangooITMT/rag/tree/project/chat',
    data
})
// 关联课题
export const relativeTopic = (data: {
    json_data: any
}): Promise<any> => request({
    method: 'POST',
    url: '/api_rag/itmt/rag/requirments/related',
    data
})